module.exports = __webpack_public_path__ + "img/img6.ad4e1ae9.png";